/* HorseHalo VIP landing. Namespaced; no globals beyond window.VIPLanding. */
(function(){
  'use strict';
  if (window.VIPLanding) return;
  window.VIPLanding = { version: '1.1.0' };
  function pad(n){ return String(n).padStart(2,'0'); }

  // Countdown(s)
  document.querySelectorAll('[data-vip-countdown]').forEach(function(box){
    var target = Date.parse(box.getAttribute('data-vip-launch'));
    if (isNaN(target)) return;
    var d = box.querySelector('[data-vip-d]'), h = box.querySelector('[data-vip-h]'), m = box.querySelector('[data-vip-m]'), s = box.querySelector('[data-vip-s]');
    function tick(){
      var diff = Math.max(0, target - Date.now());
      d.textContent = pad(Math.floor(diff/864e5));
      h.textContent = pad(Math.floor(diff%864e5/36e5));
      m.textContent = pad(Math.floor(diff%36e5/6e4));
      s.textContent = pad(Math.floor(diff%6e4/1e3));
    }
    tick(); setInterval(tick, 1000);
  });

  // Visitor local time
  document.querySelectorAll('[data-vip-localtime]').forEach(function(el){
    try{
      var t = new Date(el.getAttribute('data-vip-launch'));
      if (isNaN(t)) return;
      var str = t.toLocaleString(undefined,{weekday:'short',month:'short',day:'numeric',hour:'numeric',minute:'2-digit'});
      var zone = (Intl.DateTimeFormat().resolvedOptions().timeZone || '').split('/').pop().replace(/_/g,' ');
      el.querySelector('[data-vip-localtime-val]').textContent = str + (zone ? ' (' + zone + ')' : '');
      el.hidden = false;
    }catch(e){}
  });

  // Sticky mobile CTA: visible only while the watched element (top form) is off screen; scrolls to the top section
  var sticky = document.querySelector('[data-vip-sticky]');
  if (sticky){
    var watch = document.querySelector(sticky.getAttribute('data-vip-watch') || '#vip-hero [data-vip-form]');
    if (watch && 'IntersectionObserver' in window){
      new IntersectionObserver(function(entries){
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      }).observe(watch);
    } else {
      sticky.classList.add('is-visible');
    }
  }

  // Any [data-vip-scroll] link (header button, sticky button) scrolls to its target's form and focuses the email field
  document.querySelectorAll('[data-vip-scroll]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      var href = btn.getAttribute('href') || '';
      if (href.charAt(0) !== '#') return;
      var target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      var form = target.querySelector('[data-vip-form]') || target;
      form.scrollIntoView({behavior:'smooth', block:'center'});
      var first = form.querySelector('input[type=email], input');
      first && setTimeout(function(){ first.focus({preventScroll:true}); }, 500);
    });
  });

  // Smooth-scroll in-page anchors in the VIP header
  document.querySelectorAll('.vip-nav a[href^="#"]').forEach(function(a){
    a.addEventListener('click', function(e){
      var t = document.querySelector(a.getAttribute('href'));
      if (t){ e.preventDefault(); t.scrollIntoView({behavior:'smooth', block:'start'}); }
    });
  });

})();